import * as PIXI from "pixi.js"
import { Coord } from "../types/Interface";
import generatePoints from "../utils/generator/generatePoints";


export default function drawSegments(segments:PIXI.Graphics[], cCoord:Coord, radius: number, radians: number[], clockwise: boolean) {
  const points = generatePoints(cCoord, radians, radius);
  const _rs = [[radians[0], radians[1]] , [radians[1], radians[0]]];
  const rs = clockwise ? _rs : _rs.reverse();
  const colors = [0xFDEEE4, 0xDDF9FF];
  
  segments.forEach((segment, sI) => {
    segment
      .clear()
      .moveTo(points[0].x, points[0].y)
      .lineTo(points[1].x, points[1].y)
      .arc(cCoord.x, cCoord.y, radius, rs[sI][0], rs[sI][1])
      .fill(colors[sI]);
    })
    }